import React from 'react'

export default function Contact() {
    return (
        <div className="contact">
            
            <div>
                <h1>Phone</h1>
                <h2>9075042279</h2>
            </div>
            <div>
                <h1>instagram</h1>
                <h2>miheer_hasabnis</h2>
            </div>
        </div>
       
    )
}
